export default __webpack_public_path__ + "static/media/output_image_enhanced.0209efca.png";